export const projectRoutes = [
  {
    path: '/configuracoes/projetos/:id?/:type?',
    name: 'Projects',
    meta: {
      requiresAuth: true,
      menu: true,
      navbarActions: true,
      chat: true,
      path: 'config'
    },
    component: () => import(/* webpackChunkName: 'projects-page' */ 'views/ProjectsPage')
  }
]
